/** Prefix used everywhere templates are shown (sidebar title uses singular "Template"). */
export const USER_CREATION_TEMPLATE_PREFIX = 'User Creation';

/** Full display title e.g. "User Creation - Bench Recruiter". */
export function formatUserCreationTemplateTitle(shortName) {
  const s = String(shortName || '').trim();
  if (!s) return USER_CREATION_TEMPLATE_PREFIX;
  return `${USER_CREATION_TEMPLATE_PREFIX} - ${s}`;
}

/**
 * Normalize stored template name: strip accidental duplicate prefix if pasted.
 */
export function normalizeTemplateShortName(input) {
  let s = String(input || '').trim();
  const withHyphen = `${USER_CREATION_TEMPLATE_PREFIX} - `;
  const withDash = `${USER_CREATION_TEMPLATE_PREFIX} — `;
  if (s.startsWith(withHyphen)) s = s.slice(withHyphen.length).trim();
  else if (s.startsWith(withDash)) s = s.slice(withDash.length).trim();
  return s.slice(0, 200);
}
